import { gql } from "lib/apolloClient";

export const createLibraryBookmarkMutation = gql`
  mutation createLibraryBookmark(
    $entityId: ID!
    $entityType: LIBRARY_ENTITY_TYPE_ENUM!
    $followType: LIBRARY_FOLLOW_TYPE_ENUM!
  ) {
    library {
      createLibraryBookmark(
        input: {
          entityId: $entityId
          entityType: $entityType
          followType: $followType
        }
      )
    }
  }
`;

export const removeLibraryBookmarkMutation = gql`
  mutation removeLibraryBookmark(
    $entityId: ID!
    $entityType: LIBRARY_ENTITY_TYPE_ENUM!
    $followType: LIBRARY_FOLLOW_TYPE_ENUM!
  ) {
    library {
      removeLibraryBookmark(
        input: {
          entityId: $entityId
          entityType: $entityType
          followType: $followType
        }
      )
    }
  }
`;

export const addViewCountForEntityMutation = gql`
  mutation addViewCountForEntity($input: LibraryEntityEventInput!) {
    library {
      addLibraryEntityEvent(input: $input)
    }
  }
`;
